module.exports = __webpack_public_path__ + "92e9f832a28fd293035e21d9b6983790.svg";